import React, { Component } from "react";
import { Form, Button } from "react-bootstrap";
import InputeEllipisWithTooltip from "../../../../Common/Components/InputeEllipisWithTooltip";
import BootstrapTable from "react-bootstrap-table-next";
import _ from "lodash";
import { Utils } from "../../../../Common/Utilis";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { DailyActivityService } from "../../../../Common/Services/DailyActivity";
import { DepositAuditSlideout } from "../DailyActivityEntry/DepositAuditSlideout";
import '../DailyActivityEntry/DepositAuditDA.scss'
import { confirmAlert } from "react-confirm-alert";
import { ReactPageLoader } from "../../../../Common/Components/ReactPageLoader";
class DepositAudit extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      depositAuditData: [],
      searchTerm: "",
      isModified: false,
      isDataLoading: false,
      isDataSaving: false,
      DAModal: false,
      selectedRow: {}
    };
  }

  componentDidMount(): void {
    this.GetDADepositAudit();
  }

  componentDidUpdate(prevProps) {
    if (!this.props.isLoadingDefaultDate &&
      (prevProps.selectedDate !== this.props.selectedDate ||
        prevProps.filterHotelId !== this.props.filterHotelId)
    ) {
      if (this.props.selectedDate) {
        this.GetDADepositAudit();
      } else {
        this.setState({ depositAuditData: [] });
      }
    }
  }

  GetDADepositAudit = async () => {
    const { filterHotelId, selectedDate } = this.props;
    if (!filterHotelId || !selectedDate) {
      return;
    }

    this.setState({ searchTerm: "", isDataLoading: true });

    try {
      let depositData =
        (await DailyActivityService.GetDADepositAudit(
          filterHotelId,
          selectedDate
        )) ?? [];

      depositData = depositData.map((x: any) => {
        x.pmsTotal = Utils.currencyFormatWithOutdoller(x.pmsTotal);
        x.deposit = Utils.currencyFormatWithOutdoller(x.deposit);
        x.variance = Utils.currencyFormatWithOutdoller(x.variance)
        x.checkVariance = Utils.currencyFormatWithOutdoller(x.checkVariance);
        return x;
      });

      this.setState({ depositAuditData: [] }, () => {
        this.setState({
          depositAuditData: depositData,
          isDataLoading: false,
        });
      });
    } catch (error) {
      this.setState({ depositAuditData: [], isDataLoading: false });
      console.error("Error fetching deposit data", error);
    } finally {
      if (this.state.isModified) {
        //this.handleDiscard()
      }
    }
  };

  hoverOutEllipsis = () => {
    $(".tooltip").removeClass("show");
  };

  getFilteredData = () => {
    const { searchTerm, depositAuditData } = this.state;
    let filteredData = _.cloneDeep(depositAuditData);

    const lowerSearchTerm = searchTerm.toLowerCase();

    filteredData = filteredData.filter((row: any) => {
      return (
        row.type?.toString().toLowerCase().includes(lowerSearchTerm) ||
        Utils.removeInvaildCharFromAmount(row?.pmsTotal, 16)
          ?.toString()
          .toLowerCase()
          .includes(lowerSearchTerm) ||
        Utils.removeInvaildCharFromAmount(row?.deposit, 16)
          ?.toString()
          .toLowerCase()
          .includes(lowerSearchTerm) ||
        Utils.removeInvaildCharFromAmount(row?.variance, 16)
          ?.toString()
          .toLowerCase()
          .includes(lowerSearchTerm) ||
        row?.Notes?.toString().toLowerCase().includes(lowerSearchTerm)
      );
    });

    return filteredData;
  };

  getColumns = () => {
    const { searchTerm } = this.state;
    if (this.getFilteredData()?.length === 0 || searchTerm?.trim()) {
      return this.getColumnWithoutFooter();
    } else {
      return this.getColumnsWithFooter();
    }
  };

  borderFormatter = (column, colIndex) => {
    return (
      <>
        {column.text}
        <div className="border-bottom"></div>
      </>
    );
  };

  borderFooterFormatter = (column, colIndex, { text }) => {
    return (
      <>
        <div className="border-top"></div>
        <div className="border-bottom"></div>
      </>
    );
  };

  preventInvalidKeys = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const invalidKeys = ["e", "E", "+"];
    if (invalidKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  typeRender = (cell, row) => (
    <EllipsisWithTooltip placement="bottom">
      {row.type}
    </EllipsisWithTooltip>
  )

  notesRender = (cell, row) => {
    if (row.notes) {
      return (
        <Button onClick={() => this.toggleDAModal(row)} className="btn-outline-primary border-0 more">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.25 0.25H1.75C0.925 0.25 0.25 0.925 0.25 1.75V12.25C0.25 13.075 0.925 13.75 1.75 13.75H12.25C13.075 13.75 13.75 13.075 13.75 12.25V1.75C13.75 0.925 13.075 0.25 12.25 0.25ZM7.75 10.75H4C3.5875 10.75 3.25 10.4125 3.25 10C3.25 9.5875 3.5875 9.25 4 9.25H7.75C8.1625 9.25 8.5 9.5875 8.5 10C8.5 10.4125 8.1625 10.75 7.75 10.75ZM10 7.75H4C3.5875 7.75 3.25 7.4125 3.25 7C3.25 6.5875 3.5875 6.25 4 6.25H10C10.4125 6.25 10.75 6.5875 10.75 7C10.75 7.4125 10.4125 7.75 10 7.75ZM10 4.75H4C3.5875 4.75 3.25 4.4125 3.25 4C3.25 3.5875 3.5875 3.25 4 3.25H10C10.4125 3.25 10.75 3.5875 10.75 4C10.75 4.4125 10.4125 4.75 10 4.75Z" fill="none" />
          </svg>
        </Button>
      );
    } else {
      return (
        <Button onClick={() => this.toggleDAModal(row)} className="btn-outline-primary border-0 more">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 4.25C7.5875 4.25 7.25 4.5875 7.25 5V7.25H5C4.5875 7.25 4.25 7.5875 4.25 8C4.25 8.4125 4.5875 8.75 5 8.75H7.25V11C7.25 11.4125 7.5875 11.75 8 11.75C8.4125 11.75 8.75 11.4125 8.75 11V8.75H11C11.4125 8.75 11.75 8.4125 11.75 8C11.75 7.5875 11.4125 7.25 11 7.25H8.75V5C8.75 4.5875 8.4125 4.25 8 4.25ZM8 0.5C3.86 0.5 0.5 3.86 0.5 8C0.5 12.14 3.86 15.5 8 15.5C12.14 15.5 15.5 12.14 15.5 8C15.5 3.86 12.14 0.5 8 0.5ZM8 14C4.6925 14 2 11.3075 2 8C2 4.6925 4.6925 2 8 2C11.3075 2 14 4.6925 14 8C14 11.3075 11.3075 14 8 14Z" fill="none" />
          </svg>
        </Button>
      );
    }
  }

  varianceRender = (cell, row) => {
    const variance = Utils.currencyFormatWithOutdoller(row?.variance);
    const variance1 = Utils.currencyFormatWithOutdoller(row?.checkVariance);
    return (
      <EllipsisWithTooltip placement="bottom">
        <div className={variance === variance1 ? "" : "text-danger"}>
          {row.variance}
        </div>
      </EllipsisWithTooltip>
    )
  }

  footerFormatterTotal = (cell, row, depositAuditData, columnType) => {
    return (
      <>
        <div className="value">
          <EllipsisWithTooltip placement="bottom">
            {Utils.currencyFormatWithOutdoller(
              depositAuditData.reduce(
                (acc, item: any) =>
                  acc +
                  (+Utils.removeInvaildCharFromAmount(columnType === "pmsTotal" ? item?.pmsTotal : columnType === "deposit" ? item?.deposit : columnType === "variance" ? item?.variance : 0) || 0),
                0
              )
            )}
          </EllipsisWithTooltip>
        </div>
        <div className="border-top"></div>
        <div className="border-bottom"></div>
      </>
    );
  }

  handleInputChange = (event, value, field, auditID) => {
    const { depositAuditData } = this.state;
    const rowIndex = depositAuditData.findIndex(
      (x: any) => x.auditID === auditID
    );
    if (field === "deposit") {
      if (
        value
          .toString()
          .split("")
          .findIndex((x) => x == ".") == 0 ||
        value.toString()?.split(".")?.length > 2
      ) {
        return;
      }

      Utils.AllowOnlyPositiveNumnberInput(event);
      value = value ? Utils.removeInvaildCharFromAmount(value) : value;
    }

    this.setState((prevState) => {
      const newData = [...prevState.depositAuditData];
      newData[rowIndex] = {
        ...newData[rowIndex],
        [field]: value,
        isModified: true,
      };
      //this.props.setCurrentTabStatusOnValuesChanges(true);
      return { depositAuditData: newData, isModified: true };
    });
  };

  handleAmountOnFocus = (field, event, auditID) => {
    const { depositAuditData } = this.state;
    const index = depositAuditData.findIndex((x: any) => x.auditID === auditID);
    let newval = !event.target.value
      ? ""
      : Utils.currencyFormatWithoutDollar(event.target.value);

    const _data = _.cloneDeep(depositAuditData);
    _data[index][field] = newval;
    this.setState({ depositAuditData: _data });
  };

  handleAmountOnBlur = (field, event, auditID) => {
    const { depositAuditData } = this.state;
    const index = depositAuditData.findIndex((x: any) => x.auditID === auditID);
    const _data = _.cloneDeep(depositAuditData);
    if (!isNaN(event.target.value)) {
      let fieldValue = !event.target.value
        ? ""
        : Utils.currencyFormatWithoutDollar(depositAuditData[index][field]);
      _data[index][field] = fieldValue;
      _data[index]["variance"] = Utils.currencyFormatWithoutDollar(_data[index]["deposit"] - _data[index]["pmsTotal"]);
    }
    this.setState({ depositAuditData: _data });
  };

  getColumnsWithFooter = () => {
    const { depositAuditData, isDataSaving } = this.state;
    let baseColumns: any[] = [
      {
        dataField: "type",
        text: "Type",
        headerClasses: "big-code-width",
        headerFormatter: this.borderFormatter,
        formatter: this.typeRender,
        footer: "",
        footerFormatter: (column, colIndex, { text }) => (
          <>
            <div className="lable">{"Totals"}</div>
            <div className="border-top"></div>
            <div className="border-bottom"></div>
          </>
        ),
      },
      {
        dataField: "pmsTotal",
        text: "PMS Total",
        classes: "align-right",
        headerClasses: "width-150 align-right",
        headerFormatter: this.borderFormatter,
        formatter: (cell, row) => (
          <EllipsisWithTooltip placement="bottom">
            {row.pmsTotal}
          </EllipsisWithTooltip>
        ),
        footer: (columnData) => columnData.reduce((acc, item) => acc + item, 0),
        footerAlign: (column, colIndex) => "right",
        footerFormatter: (cell, row) => this.footerFormatterTotal(cell, row, depositAuditData, "pmsTotal"),
      },
      {
        dataField: "",
        text: "Actual",
        classes: "align-right",
        headerClasses: "width-150 align-right",
        headerFormatter: this.borderFormatter,
        formatter: (cell, row, rowIndex) => (
          <Form.Control
            className="width-124 text-right"
            type="text"
            onKeyDown={this.preventInvalidKeys}
            value={row?.deposit || ""}
            maxLength={16}
            onFocus={(e) =>
              this.handleAmountOnFocus("deposit", e, row.auditID)
            }
            onBlur={(e) =>
              this.handleAmountOnBlur("deposit", e, row.auditID)
            }
            onChange={(e) =>
              this.handleInputChange(
                e,
                e.target.value,
                "deposit",
                row.auditID
              )
            }
          />
        ),
        footer: (columnData) => columnData.reduce((acc, item) => acc + item, 0),
        footerAlign: (column, colIndex) => "right",
        footerFormatter: (cell, row) => this.footerFormatterTotal(cell, row, depositAuditData, "deposit"),
      },
      {
        dataField: "variance",
        text: "Variance",
        classes: "align-right",
        headerClasses: "width-150 align-right",
        headerFormatter: this.borderFormatter,
        formatter: this.varianceRender,
        footer: (columnData) => columnData.reduce((acc, item) => acc + item, 0),
        footerAlign: (column, colIndex) => "right",
        footerFormatter: (cell, row) => this.footerFormatterTotal(cell, row, depositAuditData, "variance"),
      },
      {
        dataField: "notes",
        text: "Explanation",
        headerClasses: "width-100 align-center",
        classes: "das-btn align-center",
        headerFormatter: this.borderFormatter,
        formatter: this.notesRender,
        footer: "",
        footerFormatter: this.borderFooterFormatter,
      },
    ];
    return baseColumns;
  };

  getColumnWithoutFooter = () => {
    const { depositAuditData, isDataSaving } = this.state;
    let baseColumns: any[] = [
      {
        dataField: "type",
        text: "Type",
        headerClasses: "big-code-width",
        headerFormatter: this.borderFormatter,
        formatter: (cell, row) => (
          <EllipsisWithTooltip placement="bottom">
            {row.type}
          </EllipsisWithTooltip>
        ),
        footer: "",
        footerFormatter: this.borderFooterFormatter,
      },
      {
        dataField: "pmsTotal",
        text: "PMS Total",
        classes: "align-right",
        headerClasses: "width-150 align-right",
        headerFormatter: this.borderFormatter,
        formatter: (cell, row) => (
          <EllipsisWithTooltip placement="bottom">
            {row.pmsTotal}
          </EllipsisWithTooltip>
        ),
        footer: "",
        footerFormatter: this.borderFooterFormatter,
      },
      {
        dataField: "",
        text: "Actual",
        classes: "align-right",
        headerClasses: "width-150 align-right",
        headerFormatter: this.borderFormatter,
        formatter: (cell, row, rowIndex) => (
          <Form.Control
            className="width-124 text-right"
            type="text"
            onKeyDown={this.preventInvalidKeys}
            value={row?.deposit || ""}
            maxLength={16}
            onFocus={(e) =>
              this.handleAmountOnFocus("deposit", e, row.auditID)
            }
            onBlur={(e) =>
              this.handleAmountOnBlur("deposit", e, row.auditID)
            }
            onChange={(e) =>
              this.handleInputChange(
                e,
                e.target.value,
                "deposit",
                row.auditID
              )
            }
          />
        ),
        footer: "",
        footerFormatter: this.borderFooterFormatter,
      },
      {
        dataField: "variance",
        text: "Variance",
        classes: "align-right",
        headerClasses: "width-150 align-right",
        headerFormatter: this.borderFormatter,
        formatter: this.varianceRender,
        footer: "",
        footerFormatter: this.borderFooterFormatter,
      },
      {
        dataField: "notes",
        text: "Explanation",
        headerClasses: "width-100 align-center",
        classes: "das-btn align-center",
        headerFormatter: this.borderFormatter,
        formatter: this.notesRender,
        footer: "",
        footerFormatter: this.borderFooterFormatter,
      },
    ];
    return baseColumns;
  };

  render() {
    const { searchTerm, isModified, DAModal, selectedRow, isDataSaving, isDataLoading } = this.state;

    return (
      <>
        {isDataLoading ? (
          <ReactPageLoader useas={"deposit-audit"} />
        ) : (
          <div className="payment-section  reuse-sub-design">
            {DAModal && (
              <DepositAuditSlideout
                {...this.state}
                row={selectedRow}
                close={this.toggleDAModal}
                parentState={this.props}
              />
            )}
            <div className="filter-section d-flex">
              <div className="search-input">
                <Form.Control
                  type="text"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) =>
                    this.setState({ searchTerm: e.target.value })
                  }
                />
              </div>
            </div>
            <div
              className={`body-section tbl-footer ${isModified ? "footer-exist" : ""}`}
              onWheel={() => this.hoverOutEllipsis()}
            >
              <BootstrapTable
                keyField="auditID"
                data={this.getFilteredData()}
                columns={this.getColumns()}
              />
            </div>
            {isModified && (
              <div className="footer-section d-flex align-items-center">
                <div className="msg">You have unsaved changes</div>
                <div className="ml-auto action">
                  <Button
                    variant="primary"
                    type="button"
                    disabled={isDataSaving}
                    onClick={() =>
                      confirmAlert({
                        title: "Unsaved Changes",
                        message:
                          "You have unsaved changes. Do you want to discard them?",
                        buttons: [
                          {
                            label: "Yes",
                            onClick: () => this.handleDiscard(),
                          },
                          { label: "No", onClick: () => { } },
                        ],
                      })
                    }
                    className="space btn btn-primary btn-discard"
                  >
                    Discard
                  </Button>
                  <Button
                    variant="primary"
                    type="button"
                    disabled={isDataSaving}
                    //onClick={this.handleSave}
                    className="btn btn-primary"
                  >
                    Save Changes
                  </Button>
                </div>
              </div>
            )}
          </div>
        )
        }
      </>
    );
  }

  toggleDAModal = (row: any) => {
    this.setState((props) => ({
      DAModal: !props.DAModal,
      selectedRow: row === undefined ? {} : row
    }))
  }

  handleDiscard = () => {
    //this.props.setCurrentTabStatusOnValuesChanges(false);
    this.setState({ isModified: false });
    this.GetDADepositAudit();
  };
}
export default DepositAudit;